import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { 
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  CircularProgress,
  Typography,
  ListItemButton
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Assessment as AssessmentIcon,
  Add as AddIcon,
  Person as PersonIcon,
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';
import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Import components
import Dashboard from './components/Dashboard';
import PartnerReport from './components/PartnerReport';
import Leaderboard from './components/Leaderboard';
import Individual from './components/Individual';
import PartnerOpportunities from './components/PartnerOpportunities';

const drawerWidth = 240;

function App() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [orderBy, setOrderBy] = useState('Meeting Date');
  const [order, setOrder] = useState('desc');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      console.log('Fetching meetings data...');
      const response = await axios.get('https://sheets-dashboard-backend.gardner-johnson.workers.dev/api/meetings');
      
      // The data is already parsed from raw_data in the backend
      const meetings = response.data;
      console.log('Received meetings:', meetings.length);
      
      setData(meetings);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleLogMeeting = () => {
    window.open('https://script.google.com/a/macros/codeium.com/s/AKfycbz6iSZU1aJTHnjLcLEwvMzo-RT7AAHuzVf5zvkX2487JOzWmZa1GI-3Hjwy7mZ5K5TD/exec', '_blank');
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <Box sx={{ display: 'flex' }}>
          <Drawer
            variant="permanent"
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
              },
            }}
          >
            <Box sx={{ overflow: 'auto', mt: 2 }}>
              <List>
                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/">
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                </ListItem>
                
                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/partner-report">
                    <ListItemIcon>
                      <AssessmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Partner Report" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/leaderboard">
                    <ListItemIcon>
                      <AssessmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Leaderboard" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/individual">
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Individual" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/opportunities">
                    <ListItemIcon>
                      <TrendingUpIcon />
                    </ListItemIcon>
                    <ListItemText primary="Partner Opportunities" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton onClick={handleLogMeeting}>
                    <ListItemIcon>
                      <AddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Log Meeting" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          </Drawer>

          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Container maxWidth="lg">
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <Dashboard 
                      data={data}
                      orderBy={orderBy}
                      order={order}
                      handleSort={handleSort}
                      loading={loading}
                      error={error}
                    />
                  } 
                />
                <Route 
                  path="/partner-report" 
                  element={<PartnerReport data={data} loading={loading} error={error} />} 
                />
                <Route 
                  path="/leaderboard" 
                  element={<Leaderboard data={data} loading={loading} error={error} />} 
                />
                <Route 
                  path="/individual" 
                  element={<Individual data={data} loading={loading} error={error} />} 
                />
                <Route 
                  path="/opportunities" 
                  element={<PartnerOpportunities />} 
                />
              </Routes>
            </Container>
          </Box>
        </Box>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
